import { NotificationManager } from 'react-notifications';
import { downloadFromABlob } from './downloadFromABlob';

const GENERIC_ERROR = 'Ocurrió un error al intentar descargar el expediente';

export const downloadExpedientZip = async (url, { loader }) => {
  try {
    loader.show(true);

    const response = await fetch(url);

    if (response.status === 404) {
      const body = await response.json();
      const message = (body && body.data && body.data.message) || GENERIC_ERROR;
      NotificationManager.error(message);
      return;
    }

    if (Number(response.status) !== 200) {
      NotificationManager.error(GENERIC_ERROR);
      return;
    }

    const total = Number(response.headers.get('X-Documents-Total'));
    const included = Number(response.headers.get('X-Documents-Included'));
    const missing = Number(response.headers.get('X-Documents-Missing'));

    if (missing > 0) {
      NotificationManager.error(
        `No se encontraron ${missing} de ${total} documentos. Se descargaron ${included}.`
      );
    }

    downloadFromABlob(await response.blob(), 'expediente', 'zip');
  } catch {
    NotificationManager.error(GENERIC_ERROR);
  } finally {
    loader.show(false);
  }
};
